import { ModulesType } from '@app/models/client.model'

export const ops = {
  READ: 'r',
  WRITE: 'w',
}
export const pages = {
  settings: {
    name: 'settings',
    components: {
      locations: {
        name: 'locations',
      },
    },
  },
}
export const componentName = (page: string, component: string, permission?: string) => {
  return `page:${page}:${component}` + (permission ? `:${permission}` : '')
}
export interface IPermissionsList {
  modules: Array<{
    name: string
    icon: string
    // No `module` here on purpose: a page's permissions are checked from every client module
    // (Authorized clients use dashboard, events, settings…), so a page never belongs to one.
    // Only the subscription switches under `modules` carry a client module (their group's `module`).
    toggleEnabled?: boolean
    permissionGroups: Array<{
      name: string
      toggleEnabled: boolean
      module?: ModulesType
      components: Array<{
        name: string
      }>
    }>
  }>
}
export const permissionList: IPermissionsList = {
  modules: [
    {
      name: 'modules',
      icon: 'icon-page',
      permissionGroups: [
        {
          name: 'SportsAndCulture',
          module: 'SportsAndCulture',
          toggleEnabled: true,
          components: [],
        },
        {
          name: 'Timewatch',
          module: 'Timewatch',
          toggleEnabled: true,
          components: [],
        },
        {
          name: 'Visitors',
          module: 'Visitors',
          toggleEnabled: true,
          components: [],
        },
        // Without these a role made on the Roles page could never open the module: the navbar
        // offers a client module only to a user holding `modules:<module>` (QA 14/10/2026).
        // Kindergarten and Nursing are left out on purpose: see RETIRED_MODULES.
        {
          name: 'Residential',
          module: 'Residential',
          toggleEnabled: true,
          components: [],
        },
        {
          name: 'Authorized',
          module: 'Authorized',
          toggleEnabled: true,
          components: [],
        },
        {
          name: 'Courses',
          module: 'Courses',
          toggleEnabled: true,
          components: [],
        },
      ],
      toggleEnabled: true,
    },
    {
      name: 'general',
      icon: 'icon-statistics',
      permissionGroups: [
        {
          name: 'components',
          toggleEnabled: false,
          components: [{ name: 'emergency_open' }, { name: 'push_message_event' }, { name: 'push_message_subscribers' }, { name: 'delete_subscriber' }],
        },
      ],
      toggleEnabled: false,
    },
    {
      name: 'dashboard',
      icon: 'icon-page',
      permissionGroups: [
        {
          name: 'kpi_panel',
          toggleEnabled: true,
          components: [
            { name: 'edit_kpi' },
            { name: 'kpi_qrix_usage' },
            { name: 'kpi_transferred_tickets' },
            { name: 'kpi_blocked_fraud' },
            { name: 'kpi_unauthentic_blocked' },
            { name: 'kpi_entrance_rate' },
            { name: 'kpi_occupancy_rate' },
            { name: 'kpi_max_expected_scanners' },
          ],
        },
        {
          name: 'upcoming_events_panel',
          toggleEnabled: true,
          components: [{ name: 'new_event' }, { name: 'edit_running_event' }],
        },
      ],
      toggleEnabled: true,
    },
    {
      name: 'events',
      icon: 'icon-calendar_fill',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'general',
          toggleEnabled: false,
          components: [{ name: 'new_event' }, { name: 'edit_event' }, { name: 'edit_running_event' }],
        },
        {
          name: 'event_buttons',
          toggleEnabled: false,
          components: [{ name: 'reset_scans' }, { name: 'edit_event' }],
        },
      ],
    },
    {
      name: 'subscribers',
      icon: 'icon-pencil_fill',
      toggleEnabled: true,

      permissionGroups: [
        {
          name: 'general',
          toggleEnabled: false,
          components: [{ name: 'import_subscribers' }, { name: 'export_subscribers' }, { name: 'new_subscriber' }, { name: 'transfer_lock' }, { name: 'edit_subscriber' }],
        },
      ],
    },
    {
      name: 'settings',
      icon: 'icon-settings',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'business_details',
          toggleEnabled: true,
          components: [{ name: 'edit_business_details' }],
        },
        {
          name: 'manage_clients',
          toggleEnabled: true,
          components: [{ name: 'new_client' }, { name: 'edit_client' }, { name: 'delete_client' }],
        },
        {
          name: 'users',
          toggleEnabled: true,
          components: [{ name: 'new_user' }, { name: 'edit_user' }],
        },
        {
          name: 'permissions',
          toggleEnabled: true,
          components: [{ name: 'new_role' }, { name: 'delete_role' }, { name: 'edit_permission' }],
        },
        {
          name: 'billing',
          toggleEnabled: true,
          components: [],
        },
        {
          name: 'limits_status',
          toggleEnabled: true,
          components: [],
        },
        {
          name: 'locations',
          toggleEnabled: true,
          components: [{ name: 'new_location' }, { name: 'edit_location' }],
        },
        {
          name: 'clubs',
          toggleEnabled: true,
          components: [{ name: 'new_club' }, { name: 'edit_club' }],
        },
        {
          name: 'station_call_groups',
          toggleEnabled: true,
          components: [{ name: 'create_group' }, { name: 'edit_group' }, { name: 'delete_group' }],
        },
      ],
    },
    {
      name: 'timewatch_settings',
      icon: 'icon-pencil_fill',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'general',
          toggleEnabled: false,
          components: [{ name: 'feature1' }, { name: 'feature2' }, { name: 'feature3' }],
        },
      ],
    },
    {
      name: 'employees',
      icon: 'icon-users',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'general',
          toggleEnabled: true,
          components: [{ name: 'view_employee' }, { name: 'edit_employee' }, { name: 'create_employee' }, { name: 'delete_employee' }],
        },
      ],
    },
    {
      name: 'authorized',
      icon: 'icon-badge',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'general',
          toggleEnabled: true,
          components: [{ name: 'view_authorized' }, { name: 'edit_authorized' }, { name: 'create_authorized' }, { name: 'delete_authorized' }],
        },
      ],
    },
    /* Service Utilities (YB-2120). Groups mirror the page's own sections, so granting
       a tool reads the same way in the permissions screen as it looks on the page.
       The cleanup section arrives with the tools that belong to it — an empty group
       here would be a switch that grants nothing. */
    {
      name: 'service_utilities',
      icon: 'icon-import',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'import',
          toggleEnabled: true,
          components: [{ name: 'import_passes' }],
        },
        {
          name: 'bulk_edit',
          toggleEnabled: true,
          components: [{ name: 'bulk_area_update' }],
        },
      ],
    },
    {
      name: 'bookings',
      icon: 'icon-calendar_fill',
      toggleEnabled: true,
      permissionGroups: [
        {
          name: 'general',
          toggleEnabled: true,
          components: [{ name: 'view' }, { name: 'create' }, { name: 'cancel' }, { name: 'extend' }, { name: 'evict' }, { name: 'configure' }],
        },
      ],
    },
  ],
}
export const allPermissions = {
  general: {
    name: 'general',
    icon: 'icon-page',
    toggleEnabled: false,
    groups: {
      components: {
        name: 'general:components',
        toggleEnabled: false,
        components: {
          emergency_open: 'general:components:emergency_open',
          push_message_event: 'general:components:push_message_event',
          push_message_subscribers: 'general:components:push_message_subscribers',
          delete_subscriber: 'general:components:delete_subscriber',
        },
      },
    },
  },
  dashboard: {
    name: 'dashboard',
    icon: 'icon-page',
    toggleEnabled: true,
    groups: {
      kpi_panel: {
        name: 'dashboard:kpi_panel',
        toggleEnabled: true,
        components: {
          edit_kpi: 'dashboard:kpi_panel:edit_kpi',
          kpi_blocked_fraud: 'dashboard:kpi_panel:kpi_blocked_fraud',
          kpi_qrix_reg: 'dashboard:kpi_panel:kpi_qrix_reg',
          kpi_subscriber: 'dashboard:kpi_panel:kpi_subscriber',
        },
      },
      upcoming_events_panel: {
        name: 'dashboard:upcoming_events_panel',
        toggleEnabled: true,
        components: {
          new_event: 'dashboard:upcoming_events_panel:new_event',
          edit_running_event: 'dashboard:edit_running_event',
        },
      },
    },
  },
  events: {
    name: 'events',
    icon: 'icon-calendar_fill',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'events:general',
        toggleEnabled: true,
        components: {
          new_event: 'events:general:new_event',
          edit_event: 'events:general:edit_event',
          edit_running_event: 'events:general:edit_running_event',
        },
      },
      event_buttons: {
        name: 'events:event_buttons',
        toggleEnabled: true,
        components: {
          reset_scans: 'events:event_buttons:reset_scans',
          edit_event: 'events:event_buttons:edit_event',
        },
      },
    },
  },
  subscribers: {
    name: 'subscribers',
    icon: 'icon-pencil_fill',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'subscribers:general',
        toggleEnabled: true,
        components: {
          import_subscribers: 'subscribers:general:import_subscribers',
          export_subscribers: 'subscribers:general:export_subscribers',
          new_subscriber: 'subscribers:general:new_subscriber',
          transfer_lock: 'subscribers:general:transfer_lock',
          edit_subscriber: 'subscribers:general:edit_subscriber',
        },
      },
    },
  },
  statistics: {
    name: 'statistics',
    icon: 'icon-statistics',
    toggleEnabled: true,
    groups: {},
  },
  requirement_submissions: {
    name: 'requirement_submissions',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'requirement_submissions:general',
        toggleEnabled: true,
        components: {
          view_submission: 'requirement_submissions:general:view_submission',
          approve_reject_submission: 'requirement_submissions:general:approve_reject_submission',
        },
      },
    },
  },
  /**
   * Room booking (YB-2066). `view` gates the page itself; the rest gate individual actions, which
   * is why cancel/extend/evict are separate — cancelling a colleague's meeting and evicting someone
   * from a room they are sitting in are different levels of trust.
   */
  bookings: {
    name: 'bookings',
    icon: 'icon-calendar_fill',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'bookings:general',
        toggleEnabled: true,
        components: {
          view: 'bookings:general:view',
          create: 'bookings:general:create',
          cancel: 'bookings:general:cancel',
          extend: 'bookings:general:extend',
          evict: 'bookings:general:evict',
          configure: 'bookings:general:configure',
        },
      },
    },
  },
  settings: {
    name: 'settings',
    icon: 'icon-settings',
    toggleEnabled: true,
    groups: {
      business_details: {
        name: 'settings:business_details',
        toggleEnabled: true,
        components: {
          edit_business_details: 'settings:business_details:edit_business_details',
          generate_api_token: 'settings:business_details:generate_api_token',
        },
      },
      manage_clients: {
        name: 'settings:manage_clients',
        toggleEnabled: true,
        components: {
          new_client: 'settings:manage_clients:new_client',
          edit_client: 'settings:manage_clients:edit_client',
          delete_client: 'settings:manage_clients:delete_client',
        },
      },
      users: {
        name: 'settings:users',
        toggleEnabled: true,
        components: {
          new_user: 'settings:users:new_user',
          edit_user: 'settings:users:edit_user',
        },
      },
      events: {
        name: 'settings:events',
        toggleEnabled: true,
        components: {
          new_location: 'settings:events:new_event',
          edit_location: 'settings:events:edit_event',
        },
      },
      locations: {
        name: 'settings:locations',
        toggleEnabled: true,
        components: {
          new_location: 'settings:locations:new_location',
          edit_location: 'settings:locations:edit_location',
        },
      },
      uploads: {
        name: 'settings:uploads',
        toggleEnabled: true,
        components: {
          new_upload: 'settings:uploads:new_upload',
          edit_upload: 'settings:uploads:edit_upload',
        },
      },
      requirements: {
        name: 'settings:requirements',
        toggleEnabled: true,
        components: {
          new_requirement: 'settings:requirements:new_requirement',
          edit_requirement: 'settings:requirements:edit_requirement',
        },
      },
      permissions: {
        name: 'settings:permissions',
        components: {
          new_role: 'settings:permissions:new_role',
          delete_role: 'settings:permissions:delete_role',
          edit_permission: 'settings:permissions:edit_permission',
        },
      },
      billing: {
        name: 'settings:billing',
        toggleEnabled: true,
        components: {},
      },
      limits_status: {
        name: 'settings:limits_status',
        toggleEnabled: true,
        components: {},
      },
      clubs: {
        name: 'settings:clubs',
        toggleEnabled: true,
        components: {
          new_club: 'settings:clubs:new_club',
          edit_club: 'settings:clubs:edit_club',
        },
      },
      employee_settings: {
        name: 'settings:employee_settings',
        toggleEnabled: true,
        components: {
          new_employee_role: 'settings:employee_settings:new_employee_role',
          edit_employee_role: 'settings:employee_settings:edit_employee_role',
          new_employee_agreement: 'settings:employee_settings:new_employee_agreement',
          edit_employee_agreement: 'settings:employee_settings:edit_employee_agreement',
        },
      },
      authorized_settings: {
        name: 'settings:authorized_settings',
        toggleEnabled: true,
        components: {
          new_authorized_category: 'settings:authorized_settings:new_authorized_category',
          edit_authorized_category: 'settings:authorized_settings:edit_authorized_category',
        },
      },
      vehicle_settings: {
        name: 'settings:vehicle_settings',
        toggleEnabled: true,
        components: {
          new_vehicle_role: 'settings:vehicle_settings:new_vehicle_role',
          edit_vehicle_role: 'settings:vehicle_settings:edit_vehicle_role',
        },
      },
      hme_settings: {
        name: 'settings:hme_settings',
        toggleEnabled: true,
        components: {
          new_hme_role: 'settings:hme_settings:new_hme_role',
          edit_hme_role: 'settings:hme_settings:edit_hme_role',
        },
      },
      station_call_groups: {
        name: 'settings:station_call_groups',
        toggleEnabled: true,
        components: {
          create_group: 'settings:station_call_groups:create_group',
          edit_group: 'settings:station_call_groups:edit_group',
          delete_group: 'settings:station_call_groups:delete_group',
        },
      },
    },
  },
  orders: {
    name: 'orders',
  },
  authorized: {
    name: 'authorized',
    icon: 'icon-badge',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'authorized:general',
        toggleEnabled: true,
        components: {
          view_authorized: 'authorized:general:view_authorized',
          edit_authorized: 'authorized:general:edit_authorized',
          create_authorized: 'authorized:general:create_authorized',
          delete_authorized: 'authorized:general:delete_authorized',
        },
      },
    },
  },
  /**
   * Service Utilities (YB-2120).
   *
   * These strings must stay in lock-step with the `service_utilities` entry in
   * `permissionList.modules` above. The two structures are separate on purpose —
   * one is what can be GRANTED, the other is what can be CHECKED — but a permission
   * present in only one is broken in a way nothing reports: missing here it cannot be
   * referenced in code, missing there it can never be granted to anyone.
   */
  service_utilities: {
    name: 'service_utilities',
    icon: 'icon-import',
    toggleEnabled: true,
    groups: {
      import: {
        name: 'service_utilities:import',
        toggleEnabled: true,
        components: {
          import_passes: 'service_utilities:import:import_passes',
        },
      },
      bulk_edit: {
        name: 'service_utilities:bulk_edit',
        toggleEnabled: true,
        components: {
          bulk_area_update: 'service_utilities:bulk_edit:bulk_area_update',
        },
      },
    },
  },
  vehicles: {
    name: 'vehicles',
    icon: 'icon-car',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'vehicles:general',
        toggleEnabled: true,
        components: {
          view_vehicle: 'vehicles:general:view_vehicle',
          edit_vehicle: 'vehicles:general:edit_vehicle',
          create_vehicle: 'vehicles:general:create_vehicle',
          delete_vehicle: 'vehicles:general:delete_vehicle',
        },
      },
    },
  },
  employees: {
    name: 'employees',
    icon: 'icon-users',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'employees:general',
        toggleEnabled: true,
        components: {
          view_employee: 'employees:general:view_employee',
          edit_employee: 'employees:general:edit_employee',
          create_employee: 'employees:general:create_employee',
          delete_employee: 'employees:general:delete_employee',
        },
      },
    },
  },
  hme: {
    name: 'hme',
    icon: 'icon-car',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'hme:general',
        toggleEnabled: true,
        components: {
          view_vehicle: 'hme:general:view_vehicle',
          edit_vehicle: 'hme:general:edit_vehicle',
          create_vehicle: 'hme:general:create_vehicle',
        },
      },
    },
  },
  messages: {
    name: 'messages',
  },
  reports: {
    name: 'reports',
  },
  /**
   * Entry Control (the entry monitor page). `open_stations` (YB-2271) adds the stations panel: a guard
   * role sees every station of the event and opens one, without holding any event-edit permission.
   * PAPI's open_once_by_station_or_entrance accepts it next to the event-edit permissions, and
   * PAPI's PERMISSION_CATALOG must list it or a role holding it cannot be saved.
   */
  inside_dashboard: {
    name: 'inside_dashboard',
    icon: 'sensors',
    toggleEnabled: true,
    groups: {
      general: {
        name: 'inside_dashboard:general',
        toggleEnabled: true,
        components: {
          open_stations: 'inside_dashboard:general:open_stations',
        },
      },
    },
  },
}
